import React, { useEffect, useState } from "react";
import {
  CButton,
  CModal,
  CModalHeader,
  CForm,
  CFormInput,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CImage,
} from "@coreui/react";
import { Constants } from "src/Constants";
import { useDispatch } from "react-redux";
import { EditSpecialities } from "src/Thunk/adminThunks";

export const EditSpecialityModal = ({ data, visible, onClose }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    clinic_fare: "",
    online_fare: "",
    specialityIcon: "",
    file: null,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        ...formData,
        name: data.name,
        clinic_fare: data.clinic_fare,
        online_fare: data.online_fare,
        specialityIcon: data.specialityIcon,
      });
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      file: e.target.files[0],
    });
  };

  const handleSave = () => {
    const bodyData = new FormData();
    bodyData.append("specialityIcon", formData.file);
    bodyData.append(
      "specialities",
      JSON.stringify({
        name: formData.name,
        online_fare: formData.online_fare,
        clinic_fare: formData.clinic_fare,
      })
    );
    dispatch(EditSpecialities({ id: data._id, body: bodyData }));
  };

  console.log(formData);

  return (
    <CModal
      alignment="center"
      visible={visible}
      onClose={onClose}
      aria-labelledby="VerticallyCenteredExample"
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          Edit Speciality
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CFormInput
            type="text"
            label="Name*"
            name="name"
            value={formData.name}
            className="mb-2"
            placeholder="Enter name"
            onChange={handleInputChange}
          />
          <CFormInput
            type="text"
            label="Clinic Fare*"
            name="clinic_fare"
            value={formData.clinic_fare}
            className="mb-2"
            placeholder="Enter clinic fare"
            onChange={handleInputChange}
          />
          <CFormInput
            type="text"
            label="Online Fare*"
            name="online_fare"
            value={formData.online_fare}
            placeholder="Enter online fare"
            onChange={handleInputChange}
          />
          <h6 className="text-sm my-2">Previous Uploaded Image</h6>
          <CImage
            className="mb-4"
            rounded
            thumbnail
            src={`${Constants.getAsset}${formData.specialityIcon}`}
            width={80}
          />
          <div className="mb-3">
            <label htmlFor="formFile" className="form-label">
              Upload New Speciality Icon
            </label>
            <CFormInput type="file" id="formFile" onChange={handleFileChange} />
          </div>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton
          color="danger"
          shape="rounded-pill"
          className="closebtn-coreui"
          onClick={onClose}
        >
          Close
        </CButton>
        <CButton color="primary" shape="rounded-pill" onClick={handleSave}>
          Save
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
